import { render } from "./ImageOverlayer.vue?vue&type=template&id=ec665326&scoped=true"
import script from "./ImageOverlayer.vue?vue&type=script&lang=js"
export * from "./ImageOverlayer.vue?vue&type=script&lang=js"

import "./ImageOverlayer.vue?vue&type=style&index=0&id=ec665326&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec665326"]])

export default __exports__